import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  SelectInput,
  ShowButton
} from 'react-admin';

import { BooleanField } from './BooleanField';

export const UserList = (props) => (
  <List
    {...props}
    filters={userFilters}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="full_name" label="Nome" />
      <TextField source="nick_name" label="Nickname" />
      <BooleanField source="is_blocked" label="Status" />
      <ShowButton basePath="/users" />
    </Datagrid>
  </List>
);

const userFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput
    source="is_premium"
    label="Status"
    choices={[
      { id: 0, name: 'Free' },
      { id: 1, name: 'Premium' },
    ]}
  />
];